import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";
import { updateAssumptionAPI } from "../../../api/financial-management-api";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "23px",
  },
  editor: {
    marginTop: "15px",
    "& .ql-editor": {
      minHeight: "200px",
    },
  },
  contentDisplay: {
    minHeight: 100,
    backgroundColor: "#FFFFFF",
    padding: theme.spacing(1),
    marginTop: "15px",
  },
  editBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "2px 8px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
  },
  editIcon: {
    color: "#0070D2",
    fontSize: "14px",
    marginTop: "2px",
  },
  editText: {
    color: "#0070D2",
    marginLeft: "4px",
    fontWeight: 600,
    fontSize: "13px",
  },
  saveBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    marginRight: "8px",
    display: "inline-flex",
    alignItems: "center",
  },
  cancelBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
  },
  tableTitle: {
    width: "220px",
    height: "36px",
    padding: "0 0 0 12px",
    fontSize: "15px",
    color: "#ffffff",
    backgroundColor: "#000",
    borderRadius: "0 10px 0 0",
    display: "flex",
    alignItems: "center",
    // marginTop:"43px"
  },
}));

export default function RichTextWithMui({ assumptionData, getVersionStatus }) {
  const classes = useStyles();

  const [content, setContent] = useState("");
  const [orginalData, setOrginalData] = useState(content);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();

  const handleEdit = () => {
    setIsEditing(true);
  };
  const onChangeText = (key, value) => {
    const changedData = {
      ...content,
    };
    changedData[key] = value;
    setContent(changedData);
  };

  useEffect(() => {
    if (assumptionData) {
      setLoading(false);
      setContent(assumptionData);
      setOrginalData(assumptionData);
    } else {
      setContent(assumptionData);
      setOrginalData(assumptionData);
    }
  }, [assumptionData]);

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const handleCancel = () => {
    setContent(orginalData);
    setIsEditing(false);
  };

  const handleSave = () => {
    setLoading(true);
    updateAssumptionAPI(content).then((res) => {
      if (res.status === 200) {
        setIsEditing(false);
        setLoading(false);
        setEmptyErrMsg(true);
        setMsgType("success");
        setMsgText("Data updated successfully");
        setOrginalData(content);
      }
      if (res.status === 400) {
        setLoading(false);
        setEmptyErrMsg(true);
        setIsEditing(false);
        setMsgType("error");
        setMsgText(res.message);
      }
    });
  };

  return (
    <>
      <div className={classes.container}>
        <div className={classes.tableTitle}>Contract Assumption</div>
        <div
          style={{ display: "flex", alignItems: "center", marginRight: "6px" }}
        >
          {!content.message &&
            getVersionStatus.toLowerCase() !== "closed" &&
            (!isEditing ? (
              <div className={classes.editBtn} onClick={handleEdit}>
                <EditIcon className={classes.editIcon} />
                <span className={classes.editText}>Edit</span>
              </div>
            ) : (
              <>
                <span className={classes.saveBtn} onClick={handleSave}>
                  <span className={classes.editText}>Save</span>
                </span>
                <span className={classes.cancelBtn} onClick={handleCancel}>
                  <span className={classes.editText}>Cancel</span>
                </span>
              </>
            ))}
        </div>
      </div>

      <div style={{ width: "100%", marginTop: "10px" }}>
        {isEditing ? (
          <ReactQuill
            value={content.assumption}
            onChange={(value) => onChangeText("assumption", value)}
            className={classes.editor}
          />
        ) : (
          <div
            className={classes.contentDisplay}
            dangerouslySetInnerHTML={{
              __html: content.assumption || content.message || "",
            }}
          />
        )}
      </div>
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
    </>
  );
}
